



























	import Vue, { PropType } from 'vue';
    import _moderation from '../../services/endpoints/moderation';
	import { ModRaid } from 'models/Raid';
	import { Spieler } from 'models/Spieler';
	import { UserRole } from '../../../../models/Enums';

    export default Vue.extend({
        name: "ModRaidSpielerEinladenComp",
        // props: ['raid'],
		props: {
			raid: Object as PropType<ModRaid>
		},
        data: () => ({
            open: false,
            invitablePlayers: [] as Spieler[],
            filterText: '',
        }),
        computed: {
            filteredPlayers: function(): Spieler[] {
                return this.invitablePlayers.filter(u => this.isInNameFilter(u));
            },
			disabled: function(): boolean {
				return this.$vStore.getters.loggedInUser.role <= UserRole.Maz;
			}
        },
        methods: {
            add: async function(spieler: Spieler): Promise<void> {
                await _moderation.addSpieler(this.raid.id, spieler.id, spieler.accname, this.raid.name);
                this.$emit('refresh');
            },
            refreshInvitable: async function(): Promise<void> {
                this.invitablePlayers = await _moderation.invitablePlayers(this.raid.id);
            },
            isInNameFilter: function(user: Spieler): boolean {
                const name = user.name.toLowerCase();
                const accname = user.accname.toLowerCase();
                const searchText = this.filterText.toLowerCase();

                return name.indexOf(searchText) > -1 ||
                    accname.indexOf(searchText) > -1
            },
        },
        created: async function(): Promise<void> {
            this.invitablePlayers = await _moderation.invitablePlayers(this.raid.id);
        }
    })
